import React, { ChangeEvent } from "react";

import { Box, Checkbox, TextField } from "@mui/material";
import FormControlLabel from "@mui/material/FormControlLabel";
import { IndexedCardInfo } from "@akj-dev/shared-components";

import { HostEnv } from "../../../Cpq";
import { useAccountSettings } from "../../../shared/hooks/useAccountSettings";
import { useSelector } from "react-redux";

interface OrderContainerProps {
  cardIndex: string;
  order: Record<string, any>;
  hostEnv: HostEnv;
  setReceiveUpdatesField: (
    _: ChangeEvent<HTMLInputElement>,
    isInputChecked: boolean
  ) => void;
  setWelcomeEmailField: (
    _: ChangeEvent<HTMLInputElement>,
    isInputChecked: boolean
  ) => void;
  setCustomerPurchaseNumber: (newCustomerPurchaseNumber: string) => void;
  setOfcomPricingInfo: (ofcomPricingInfo: string) => void;
  setCreditCheckConsentField: (
    _: ChangeEvent<HTMLInputElement>,
    isInputChecked: boolean
  ) => void;
}

export const Order = ({
  cardIndex,
  order,
  hostEnv,
  setReceiveUpdatesField,
  setWelcomeEmailField,
  setCustomerPurchaseNumber,
  setOfcomPricingInfo,
  setCreditCheckConsentField,
}: OrderContainerProps) => {
  const accountSettings = useAccountSettings();

  const isVfDirect = accountSettings.can_access_vf_direct === "1";
  const isNewAccountForCreditCheck = useSelector<any, boolean>(
    (state) =>
      state.account.createAccount.response?.data?.account
        ?.is_new_account_for_credit_check === 1
  );
  const isNew = useSelector<any, boolean>(
    (state) => state.account.creditCheckStatus.response?.data?.is_new === 1
  );
  return (
    <IndexedCardInfo index={cardIndex} title="Order">
      <TextField
        variant="standard"
        label="Purchase order number"
        fullWidth
        onChange={(event) => setCustomerPurchaseNumber(event.target.value)}
        value={order.customer_purchase_number || ""}
      />
      {accountSettings.as_can_set_order_updates === "1" && (
        <FormControlLabel
          label="I want to receive updates on this order"
          control={
            <Checkbox
              color="secondary"
              name="cc_sales_person"
              onChange={setReceiveUpdatesField}
              checked={order.cc_sales_person || false}
            />
          }
        />
      )}
      {accountSettings.as_ofcom_text_required === "1" && (
        <TextField
          variant="standard"
          label="Ofcom Pricing Information"
          fullWidth
          multiline
          minRows={4}
          onChange={(event) => setOfcomPricingInfo(event.target.value)}
          value={order.ofcomPricingInfo || ""}
        />
      )}
      <Box sx={{ display: "flex", flexDirection: "column" }}>
        {accountSettings.dws_reseller_enabled !== "1" &&
          accountSettings.can_access_vf_direct !== "1" &&
          hostEnv !== "my_account" && (
            <FormControlLabel
              label="Send welcome email"
              control={
                <Checkbox
                  color="secondary"
                  onChange={setWelcomeEmailField}
                  checked={!order.suppress_welcome_email}
                  data-cy="sendWelcomeEmail"
                />
              }
            />
          )}
        {!isVfDirect && (isNewAccountForCreditCheck || isNew) && (
          <FormControlLabel
            label="I confirm that I have obtained the customer’s explicit consent to perform a credit check"
            control={
              <Checkbox
                color="secondary"
                onChange={setCreditCheckConsentField}
                checked={order.creditCheckConsent}
              />
            }
          />
        )}
      </Box>
    </IndexedCardInfo>
  );
};
